import { render, staticRenderFns } from "./IzinTamuViewNew.vue?vue&type=template&id=313c14f6&scoped=true&lang=pug&"
import script from "./IzinTamuViewNew.vue?vue&type=script&lang=js&"
export * from "./IzinTamuViewNew.vue?vue&type=script&lang=js&"
import style0 from "./IzinTamuViewNew.vue?vue&type=style&index=0&id=313c14f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313c14f6",
  null
  
)

export default component.exports